import * as React from "react";

const ChevronLeft: React.FC = () => {
    return <svg width="8px" height="12px" viewBox="0 0 8 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-505.000000, -358.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(424.000000, 128.000000)">
                    <polygon points="9.75 10.6 5.05 6 9.75 1.4 8.35 0 2.25 6 8.35 12"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(ChevronLeft);
